module.exports = __webpack_public_path__ + "img/custom_filter.fcd3befa.png";